import './styles/SignInModal.css';
import React, { useState,useContext  } from 'react';
import { AuthContext } from "../context/AuthContext";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { IoClose } from 'react-icons/io5'; 

const SignInModal = ({ onClose }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  

  const [showForgot, setShowForgot] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotMsg, setForgotMsg] = useState('');

  const navigate = useNavigate();
  const { setUser } = useContext(AuthContext);
  
  const handleSignUpClick = async (e) => {
    e.preventDefault();
    try {
    const res = await axios.post(`${apiUrl}/login`,
        { email, password },
        { withCredentials: true }
      );
      setMessage("Login successful!");
      setUser(res.data.user);
      console.log('token', res.data.user.token);
      
      localStorage.setItem('token', res.data.user.token);

      if (res.data.user.role === 'admin') {
        navigate('/dashboard');
        return;
      }
      if (res.data.user.role === 'user') {
        navigate('/question');
      }
    } catch (err) {
      setMessage(err.response?.data?.msg || 'Login failed');
    }
  
};

 const handleForgotSubmit = async (e) => {
  e.preventDefault();
  setForgotMsg("");
  try {
    const res = await axios.post(`${apiUrl}/forgetpassword`, {
      email: forgotEmail
    });
    setForgotMsg(res.data.message);
  } catch (err) {
     setForgotMsg(err.response?.data?.error || "Failed to send link");
  }
};
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>
          <IoClose size={24} />
        </button>

        <h2 className="modal-title">Sign in</h2>
         <form className="login-form" onSubmit={handleSignUpClick}>
          <div className="form-group">
            <label htmlFor="email">EMAIL</label>
            <input type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required />
          </div>

          <div className="form-group">
            <label htmlFor="password">PASSWORD</label>
            <input type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required />
          </div>

         <button className="btn-signin">Sign in</button>
          <div style={{ color: 'red', marginTop: '8px' }}>{message}</div>
        </form>

         <p className="forgot-link" style={{ cursor: 'pointer' }}
          onClick={() => setShowForgot(true)}>
          Forgot your password?
        </p>

        <p className="terms">
          By clicking continue above, you acknowledge that you have read,
          understood and agree to our <span>Terms & Conditions.</span>
        </p>
       
        {showForgot && (
          <div className="forgot-modal">
            <h3>Forgot Password</h3>
            <form onSubmit={handleForgotSubmit}>
              <input
                type="email"
                placeholder="Enter your email"
                value={forgotEmail}
                onChange={e => setForgotEmail(e.target.value)}
                required
              />
              <button type="submit" className='reset-btn'>Send Reset Link</button>
            </form>
            <div style={{ color: 'green', marginTop: '8px' }}>{forgotMsg}</div>
            <button onClick={() => setShowForgot(false)} style={{ marginTop: '8px' }} className='closebutton'>Close</button>
          </div>
        )}

      </div>
    </div>
  );
};

export default SignInModal;

